import * as React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-hooks';
import Inner from './Inner';
import { useGraphQLClient } from '../../graphql-client';
import Analytics from './Analytics';
import IsDemo from './IsDemo';
import AccessDeniedError from './AccessDeniedError';
import { AuthRequiredForSecondaryOps } from '@entities/error';
import GoogleOneTapSignIn from './GoogleOneTapSignIn';
import { useVarioqub, VarioqubContext } from '../../Varioqub/varioqub';
import { GuardedApolloProvider } from '../../GuardedApolloProvider';
import { BootstrapGate } from '@shared/ui';
import PixelPageViewWatcher from './PixelPageViewWatcher';
const Engine = ({ before, after }) => {
    const client = useGraphQLClient();
    const varioqub = useVarioqub();
    return (React.createElement(BootstrapGate, null,
        React.createElement(Router, null,
            React.createElement(Analytics, null),
            React.createElement(IsDemo, null),
            React.createElement(AccessDeniedError, null),
            React.createElement(PixelPageViewWatcher, null),
            React.createElement(ApolloProvider, { client: client },
                React.createElement(AuthRequiredForSecondaryOps, null),
                React.createElement(GoogleOneTapSignIn, null),
                React.createElement(GuardedApolloProvider, { client: client },
                    before,
                    React.createElement(VarioqubContext.Provider, { value: varioqub },
                        React.createElement(Inner, null)),
                    after)))));
};
export default Engine;
